export default __webpack_public_path__ + "static/media/fw-victoria-er-White Gold.65254fc8.mp4";